export type ClubRoute = {
	key: string;
	name: string;
	accent: string;
	tagline: string;
};

export const CLUB_ROUTES: ClubRoute[] = [
	{
		key: "thomastown",
		name: "Thomastown",
		accent: "from-blue-500 to-cyan-400",
		tagline: "Disciplined core"
	},
	{
		key: "vnca",
		name: "VNCA",
		accent: "from-emerald-500 to-teal-400",
		tagline: "Metro contenders"
	},
	{
		key: "himalayan",
		name: "Himalayan",
		accent: "from-orange-500 to-amber-400",
		tagline: "Explosive innings"
	},
	{
		key: "donath",
		name: "Donath",
		accent: "from-rose-500 to-red-400",
		tagline: "Fast-bowling pressure"
	},
	{
		key: "prestondruids",
		name: "Preston Druids",
		accent: "from-indigo-500 to-sky-400",
		tagline: "Smart matchups"
	},
	{
		key: "coburg",
		name: "Coburg",
		accent: "from-lime-500 to-emerald-400",
		tagline: "Relentless fielding"
	},
	{
		key: "frankstonpeninsula",
		name: "Frankston Peninsula",
		accent: "from-fuchsia-500 to-pink-400",
		tagline: "Powerplay specialists"
	},
	{
		key: "australia",
		name: "Australia",
		accent: "from-yellow-500 to-orange-400",
		tagline: "National benchmark"
	}
];
